import * as React from 'react';
import { useTheme } from '@mui/material/styles';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Bs4MainDispatch from '../Bs4MainDispatch'

export const Bs4ShowRequest = (props) => {      

  const handleClickButton = (event, button) => {      
    Bs4MainDispatch.commandParser('Bs4AfterRequest', {      
      questionId: props.message?.questionId || null,
      buttonId: button?.buttonId || null,
    }, null);
    handleClose();
  };

  const handleClose = () => {      
    if (props.setBs4ShowRequest) props.setBs4ShowRequest(null);
  };

  if (!props.showBs4Request) return null;

  return (
    <Dialog open onClose={handleClose}>
      <DialogTitle></DialogTitle>
      <IconButton
        aria-label="close"
        onClick={handleClose}
        sx={{
          position: 'absolute',
          right: 8,
          top: 8,
          color: (theme) => theme.palette.grey[500],
        }}
      >
        <CloseIcon />
      </IconButton>
      <DialogContent>
        <DialogContentText dangerouslySetInnerHTML={{__html: props.showBs4Request?.question}}/>
      </DialogContent>
      <DialogActions>
        {(props.showBs4Request?.buttons || []).map(button => {
          return <Button key={button.id} onClick={(event) => handleClickButton(event, button)}>{button.text}</Button>
        })}      
      </DialogActions>
    </Dialog>
  )
}

export default Bs4ShowRequest;